module.exports = __webpack_public_path__ + "static/media/Christie McAllister.655daadc.png";